import { AnimatePresence, motion } from "framer-motion";

export default function AppLoadingOverlay({
  title = "Loading…",
  subtitle = "",
  visible = true,
  loaderStyle = "spinner",
  bg,
  hideContent = false,
}) {
  if (!visible) return null;
  const dotsText = title && title !== "Loading…" ? title : "Loading...";

  return (
    <div className="clientsLoadingOverlay isVisible" style={{ opacity: 1, ...(bg ? { background: bg } : {}) }}>
      {!hideContent && (
        <AnimatePresence mode="wait">
          <motion.div
            key={loaderStyle}
            initial={false}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
          >
            {loaderStyle === "dots"
              ? <div className="appDotsLoader" aria-hidden="true" />
              : <div className="clientsLoadingSpinner" aria-hidden="true" />
            }
            {loaderStyle === "dots"
              ? <div className="appTextLoader" data-text={dotsText} aria-label={dotsText} />
              : <div className="clientsLoadingTitle">{title}</div>
            }
            {subtitle ? <div className="clientsLoadingSub">{subtitle}</div> : null}
          </motion.div>
        </AnimatePresence>
      )}
    </div>
  );
}
